"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { ref: "dialog" };
const _hoisted_2 = { method: "dialog" };
const _hoisted_3 = { class: "newlines" };
const _hoisted_4 = { class: "dialog-menu centered-content" };
const _hoisted_5 = { for: "dialog-confirm-dismiss" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("dialog", _hoisted_1, [
        (0, vue_1.createElementVNode)("form", _hoisted_2, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("p", _hoisted_3, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.message), 1)
            ])), [
                [_directive_i18n]
            ]),
            (0, vue_1.createElementVNode)("menu", _hoisted_4, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("button", {
                    class: "btn btn-lg btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.accept()))
                }, [...(_cache[3] || (_cache[3] = [
                        (0, vue_1.createTextVNode)("Yes", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("button", {
                    class: "btn btn-lg",
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.dismiss()))
                }, [...(_cache[4] || (_cache[4] = [
                        (0, vue_1.createTextVNode)("No", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (_ctx.enableDontShowAgainCheckbox)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.hide) = $event)),
                        id: "dialog-confirm-dismiss"
                    }, null, 512), [
                        [vue_1.vModelCheckbox, _ctx.hide]
                    ]),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", _hoisted_5, [...(_cache[5] || (_cache[5] = [
                            (0, vue_1.createTextVNode)("Don't show this again", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ], 64))
                : (0, vue_1.createCommentVNode)("", true)
        ])
    ], 512));
}
